<template>
  <v-card class="elevation-1">
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="results"
        :search="search"
        :loading="loading"
        :show-select="options.showSelect"
        item-key="id"
        :loading-text="options.loadingText"
        :items-per-page="options.itemsPerPage"
      >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Projects ({{ results.length }})</v-toolbar-title>
        </v-toolbar>
        <v-toolbar dense flat color="white">
          <v-menu offset-y bottom right v-if="options.showSelect">
            <template v-slot:activator="{ on }">
              <v-btn outlined small v-on="on" class="mr-2" :disabled="updatingChanges">
                Action Items
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(item, index) in bulkActionItems" :key="index" @click="noop">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn color="accent"
            dark class="mr-1"
            depressed small
            :to="newProjectNav.to"
            :disabled="updatingChanges">
            <v-icon left>mdi-plus</v-icon> New Project
          </v-btn>
          <v-btn text small icon color="accent" @click="init">
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-dialog v-model="popups.edit.dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <h4 class="title">{{ formHeading }}</h4>
            </v-card-title>
            <v-card-text>
              <al-project-form v-if="popups.edit.dialog"
                @close="onClose"
                @save="onSave"
                :form-data="chosenItem">
              </al-project-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.stage="{ item }">
        <v-chip
          small
          class="ma-1"
          label
          v-if="item.stage"
        >{{ item.stage }}</v-chip>
        <span class="red--text" v-else>NA</span>
      </template>

      <template v-slot:item.plan="{ item }">
        <span v-if="item.plan" class="no-wrap">{{ item.plan.name }}</span>
        <span class="red--text" v-else>NA</span>
      </template>

      <template v-slot:item.name="{ item }">
        <router-link :to="getProjectRoute(item)" class="no-wrap">
          <v-icon small class="mr-1">mdi-link</v-icon>
          {{ item.name }}
        </router-link>
      </template>

      <template v-slot:item.contact="{ item }">
        <span v-if="item.contact">{{ item.contact.name }}</span>
        <span class="red--text" v-if="!item.contact">NA</span>
      </template>

      <template v-slot:item.startDate="{ item }">
        <span v-if="item.startDate" class="no-wrap">{{ item.startDate | moment('from') }}</span>
        <span class="red--text" v-else>NA</span>
      </template>

      <template v-slot:item.endDate="{ item }">
        <span v-if="item.endDate" class="no-wrap">{{ item.endDate | moment('from') }}</span>
        <span class="red--text" v-else>NA</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y left :min-width="dropdowns.sizes.sm">
          <template v-slot:activator="{ on }">
            <v-icon
              small
              v-on="on"
              :disabled="disableOwnAction || updatingChanges"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list dense>
            <v-list-item @click="handleDropdown(item, action)"
              v-for="(action, index) in actionItems"
              :key="index"
              v-show="action.match(item)">
              <v-list-item-icon class="mr-2">
                <v-icon small v-text="action.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'projects-list-page',
  components: {},
  data() {
    return {
      dialog: false,
      chosenItem: null,
      loading: false,
      selected: [],
      search: '',
      results: [],
      updatingChanges: false,
      popups: {
        edit: {
          dialog: false,
        },
        todo: {
          dialog: false,
        },
      },
    };
  },
  computed: {
    ...mapState([
      'dropdowns',
    ]),
    ...mapState('tables', {
      headers: state => state.projectsTable.headers,
      options: state => state.projectsTable.options,
      bulkActionItems: state => state.projectsTable.bulkActionItems,
      actionItems: state => state.projectsTable.actionItems,
    }),
    ...mapState('routes', {
      newProjectNav: state => state.NEW_PROJECT,
      projectsListNav: state => state.PROJECTS,
      projectRoute: state => state.PROJECT_INFO,
      projectTasksRoute: state => state.PROJECT_TASKS,
      proejctEditRoute: state => state.PROJECT_LIST_EDIT,
    }),
    disableOwnAction() {
      return !!this.selected.length;
    },
    formHeading() {
      return `${this.chosenItem && this.chosenItem.id ? 'Update' : 'New'} Project`;
    },
  },
  methods: {
    ...mapActions('db', {
      fetchResults: types.GET_PROJECTS,
      deleteItem: types.DELETE_PROJECT,
      deleteSelected: types.DELETE_ALL_PROJECTS,
    }),
    getProjectRoute(item) {
      if (!this.projectRoute) {
        return {};
      }
      return {
        ...this.projectRoute.to,
        params: {
          projectId: item.id,
          projectName: item.name,
        },
      };
    },
    noop() {},
    onClose() {
      this.$router.push(this.projectsListNav.to);
    },
    onSave() {
      this.$router.push(this.projectsListNav.to);
      this.loadResults();
    },
    onTodoSelect(item) {
      this.$router.push({
        ...this.projectTasksRoute.to,
        params: {
          projectId: item.id,
          projectName: item.name,
        },
      });
    },
    onTodoCancel() {
      this.chosenItem = null;
      this.popups.todo.dialog = false;
    },
    onEdit(item) {
      this.$router.push({
        ...this.proejctEditRoute.to,
        params: {
          projectId: item.id,
        },
      });
    },
    onDelete(item) {
      if (!item || !item.id) {
        return;
      }
      this.updatingChanges = true;
      this.deleteItem(item.id)
        .then(() => {
          const index = this.results.indexOf(item);
          this.results.splice(index, 1);
        }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    onMulitpleDelete() {
      if (!this.selected.length) {
        return;
      }
      this.updatingChanges = true;
      this.deleteSelected(this.selected)
        .then(() => {
          this.loadResults();
        }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    loadResults() {
      this.loading = true;
      this.fetchResults()
        .then((results) => {
          this.results = results;
        }).catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleDropdown(payload, item) {
      this[item.action](payload);
    },
    handleDialog() {
      const { openDialog } = this.$route.meta;
      const { projectId } = this.$route.params;
      if (openDialog) {
        this.chosenItem = {};
        if (projectId) {
          this.results.forEach((item) => {
            if (projectId === item.id) {
              this.chosenItem = {
                ...item,
              };
            }
          });
        }
        this.popups.edit.dialog = true;
      } else {
        this.popups.edit.dialog = false;
        this.chosenItem = {};
      }
    },
    init() {
      this.loadResults();
      this.handleDialog();
    },
  },

  created() {
    this.init();
  },

  watch: {
    $route() {
      this.handleDialog();
    },
  },
};
</script>
